import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { triggersClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation InsertFolder($input: FolderInput) {
    insertFolder(input: $input) {
      id
      name
    }
  }
`

export const useSaveFolder = onSuccess => {
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['folders'], client: triggersClient })

  const handleRequest = name => {
    const input = { name }

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        if (!!onSuccess) onSuccess(resp.data?.insertFolder)
      } else {
        notify.error({ title: 'Ocorreu um erro ao salvar!' })
      }
    })
  }

  return [handleRequest, state]
}
